/* =========================================================================
   Pellington - PDP TRUST STRIP placement. 8 September 2026.

   Moves the strip out of the product column and puts it directly after the
   gallery, so it sits under the photograph on every breakpoint where the
   gallery is a swipe slideshow (phones, below 48em).

   10 Oct 2026 (credit theme, round 5):
   - THUMBNAILS. When snippets/pell-pdp-thumbs.liquid has built its row of
     thumbnails under the gallery, the strip goes after the row, so the order
     is photo -> thumbnails -> trust line -> title. The thumbnails script
     calls window.pellPlaceStrip() after it builds, so the order is right
     whichever of the two runs first.
   - ONE PLACE PER LAYOUT. On the desktop product page (48em and up, photos
     in a grid) the strip stays where Liquid put it: first in the info
     panel, directly above the product name, on every product. The page
     re-checks when the window crosses 48em, and puts the strip back in the
     panel if it had been moved under the photos at phone width (the owner
     saw it above the name on some products and under the photos on others).

   ⚑ WHAT THIS FILE USED TO DO, AND MUST NOT DO AGAIN: it copied the gallery's
   measured offsets onto the strip so the CSS could pull it up into the
   letterbox, tight under the photograph. That pin broke swiping - the
   letterbox is part of the horizontal scroll track, so the raised strip stood
   on top of the scroll surface and swallowed any drag that began there. The
   reasoning is in assets/pell-pdp-strip.css. The offsets are not read here any
   more and .pell-gal-bar is not touched at all.

   ⚑ NO requestAnimationFrame ANYWHERE. Deliberate, and the same rule the
   gallery and card kits follow: rAF never fires when the browser pane is
   hidden, which makes correct code look broken in a harness.

   Remove the one render line in layout/theme.liquid to strip this entirely.
   The strip then renders where Liquid put it, first in the product column.
   ========================================================================= */
(function () {
  'use strict';

  var STRIP = '.pell-tt--line';
  var SHOW  = '.pdp--media-slideshow .slideshow';
  var home = null, homeNext = null;

  function place() {
    var strip = document.querySelector(STRIP);
    if (!strip) return;
    if (!home) { home = strip.parentNode; homeNext = strip.nextSibling; }

    var show = document.querySelector(SHOW);
    if (show) {
      var after = show.nextElementSibling;
      var anchor = (after && after.classList.contains('pell-thumbs')) ? after : show;
      if (strip.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', strip);
    } else if (strip.parentNode !== home) {
      /* desktop layout: back to the info panel, above the product name */
      if (homeNext && homeNext.parentNode === home) home.insertBefore(strip, homeNext);
      else home.appendChild(strip);
    }

    /* No gallery on this page for any reason: the strip stays where Liquid
       put it and is revealed, rather than hiding content that is there. */
    strip.classList.add('is-placed');
  }

  window.pellPlaceStrip = place;

  function init() {
    place();
    var mq = window.matchMedia('(max-width: 47.99em)');
    /* the desktop-scroll snippet toggles .pdp--media-slideshow on the same
       breakpoint; wait a tick so its class is in place before re-placing */
    var later = function () { setTimeout(place, 0); };
    if (mq.addEventListener) mq.addEventListener('change', later);
    else if (mq.addListener) mq.addListener(later);
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
